import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiUserStatuses extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}